var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventRelax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.503.042C17.02.039 12.708 1.813 9.468 4.995c-3.239 3.181-5.156 7.523-5.351 12.12-.196 4.597 1.347 9.094 4.304 12.552l12.465 15c.154.185.38.292.617.292a.803.803 0 0 0 .617-.292L34.252 30.05c3.089-3.415 4.755-7.933 4.643-12.591-.112-4.658-1.994-9.087-5.243-12.34C30.403 1.864 26.043.042 21.503.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.503.042C17.02.039 12.708 1.813 9.468 4.995c-3.239 3.181-5.156 7.523-5.351 12.12-.196 4.597 1.347 9.094 4.304 12.552l12.465 15c.154.185.38.292.617.292a.803.803 0 0 0 .617-.292L34.252 30.05c3.089-3.415 4.755-7.933 4.643-12.591-.112-4.658-1.994-9.087-5.243-12.34C30.403 1.864 26.043.042 21.503.04Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.503.042C17.02.039 12.708 1.813 9.468 4.995c-3.239 3.181-5.156 7.523-5.351 12.12-.196 4.597 1.347 9.094 4.304 12.552l12.465 15c.154.185.38.292.617.292a.803.803 0 0 0 .617-.292L34.252 30.05c3.089-3.415 4.755-7.933 4.643-12.591-.112-4.658-1.994-9.087-5.243-12.34C30.403 1.864 26.043.042 21.503.04Z",
    stroke: "#fff",
    strokeWidth: 2,
    mask: "url(#c)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.398 19.295-.796-.795-3.66 3.66-1.59-1.59-.794.795 2.384 2.385 4.456-4.455Zm1.852-6.045h-.75v-1.5H25v1.5h-6v-1.5h-1.5v1.5h-.75c-.832 0-1.492.675-1.492 1.5l-.008 10.5a1.5 1.5 0 0 0 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5v-10.5c0-.825-.675-1.5-1.5-1.5Zm0 12h-10.5V17h10.5v8.25Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 21.5,
    y1: 0.041,
    x2: 21.5,
    y2: 44.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF914D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13 11)",
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.1,
    y: 0.041,
    width: 42.8,
    height: 52.918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2502_101720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2502_101720",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventRelax);
export default __webpack_public_path__ + "static/media/event_relax.23eb7acc52d72be02f3a5a908299a97e.svg";
export { ForwardRef as ReactComponent };